function trackOrder(token) {
    var order_number = $("input#ordernumber").val();
    var email = $("input#email").val();

    var dataString = 'order_number='+order_number+'&email='+email+'&token='+token;
    $.ajax({
      type: "POST",
      crossDomain: true,
      url: "https://tracker.onewheel.com/include/production_query.php",
      data: dataString,
      datatype: 'json',
      success: function(output) {
        if(output.status == "success")  {
          var this_ship_date = new Date(output.ship_date);
          window.TrackOrder.toggleForm(output.order_status);
          window.TrackOrder.setShipDate(this_ship_date, output.tracking_text, output.tracking_url);
        }
        else if(output.status == "cs") {
          alert('Order on hold - please contact Customer Service\n\n1.800.283.7943\nsupport@onewheel.com');
        }
        else if( output.status == "cancelled" ) {
          alert('Order cancelled');
        }
        else {
          alert('Order not found');
        }
      }
    });
}

$(document).ready(function() {

    $("#ajax-track-order").submit(function(ev) {
        ev.preventDefault();

        var order_number = $("input#ordernumber").val();
        if( order_number == "") {
            return false;
        }

        var email = $("input#email").val();
        if( email == "" ) {
            return false;
        }

        grecaptcha.enterprise.ready(async() => {
            const token = await grecaptcha.enterprise.execute(
                '6LeI7AweAAAAAPiRiwMGpKB5hw8RtE8y-9NZDynV',
                {action: 'track'}
            );
            if( token ) {
                trackOrder(token);
            }
        });

        return false;
    });

    $("#pagerefresh").click(function(ev) {
        window.TrackOrder.toggleForm();
        window.TrackOrder.setShipDate();
        $("#order_status_note").text("Estimated Shipping");
        $(".tracking-number").html("");
    });

});
